// extracted by mini-css-extract-plugin
export default {"container":"homeProds_container__EpCa+","prods":"homeProds_prods__pyaVU"};